import styled from 'styled-components';
import { Button2, Select, Switch, theme } from '@frameio/vapor';
import { IconChevronDown } from '@frameio/vapor-icons';
import { ASPECT_RATIOS } from '../../constants';
import type { AspectRatio } from '../../types';
import TEXT from './generated/TEXT/FooterControls';

TEXT.DEFINE({
  /** Label for safe zone toggle */
  safeZone: 'Safe zone',
});

type FooterControlsProps = {
  isSafeZoneVisible: boolean;
  setIsSafeZoneVisible: () => void;
  aspectRatio: AspectRatio;
  handleAspectRatioChange: (newAspectRatio: AspectRatio) => void;
};

const aspectRatioSelectContent = Object.entries(ASPECT_RATIOS).map(
  ([, value]) => ({
    value,
    label: value,
  })
);

/**
 * FooterControls component provides controls for aspect ratio, safe zone,
 * debug mode, and template loading
 */
export const FooterControls: React.FC<FooterControlsProps> = ({
  isSafeZoneVisible,
  setIsSafeZoneVisible,
  aspectRatio,
  handleAspectRatioChange,
}) => {
  return (
    <StyledFooterControls>
      {/* Safe zone toggle */}
      <Switch
        checked={isSafeZoneVisible}
        label={TEXT.safeZone}
        onChange={setIsSafeZoneVisible}
      />
      {/* Aspect ratio selector */}
      <Select
        content={aspectRatioSelectContent}
        name="aspectRatio"
        onChange={handleAspectRatioChange}
        value={aspectRatio}
      >
        <StyledButton
          iconAfter={
            <IconChevronDown color={theme.colors.icon.secondary} size={16} />
          }
        >
          {aspectRatio}
        </StyledButton>
      </Select>
    </StyledFooterControls>
  );
};

const StyledButton = styled(Button2)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 85px;
`;

const StyledFooterControls = styled.div`
  align-items: center;
  display: flex;
  gap: ${theme.spaces[16]};
`;
